// App base URL

const getBaseUrl = (): string => {
  const envUrl = process.env.REACT_APP_MOPOZZI_API_BASE_URL || process.env.REACT_APP_DIGIASSUR_BASE_URL;
  if (envUrl) {
    return envUrl.endsWith("/api") ? envUrl : `${envUrl}/api`;
  }
  return "http://localhost:8000/api";
};

export class ApiRoute {
  static apiBaseUrl = getBaseUrl();

  static websocketUrl = `${process.env.REACT_APP_WEBSOCKET_URL || "localhost:8000/api"}/messages`;

  static searchPassenger = this.apiBaseUrl + "/passagers/passager/search";

  static login = this.apiBaseUrl + "/login_check";

  static logout = this.apiBaseUrl + "/logout";

  static refreshToken = this.apiBaseUrl + "/token/refresh";

  static profile = this.apiBaseUrl + "/profile";

  static users = this.apiBaseUrl + "/users";

  static userApiKeys = this.apiBaseUrl + "/users/me/api-keys";

  static campagnes = this.apiBaseUrl + "/campain";

  static promotional_campagnes = this.apiBaseUrl + "/promotional-campains";

  // UltraMessage & Chat
  static ultramessageChat = this.apiBaseUrl + "/ultra-message/chat";

  static sendText = this.ultramessageChat + "/text";

  static sendMedia = this.ultramessageChat + "/media";

  static getChats = this.ultramessageChat + "/get-chats";

  static getMessages = this.ultramessageChat + "/get-messages/";

  static checkPhone = this.ultramessageChat + "/check-phone";

  static chatList = this.ultramessageChat + "/chat-list";

  static contacts = this.ultramessageChat + "/contacts";

  static database_contacts = this.apiBaseUrl + "/contacts";

  static catalogs = this.apiBaseUrl + "/catalog";

  static templates = this.apiBaseUrl + "/templates";

  static template_chats = this.apiBaseUrl + "/chat";

  // CRM & Passerelles
  static yangzi = this.apiBaseUrl + "/yangzi";

  static clementino = this.apiBaseUrl + "/clementino";

  static clementinoExpeditions = this.clementino + "/expeditions";

  static clementinoPayments = this.clementino + "/payments";

  static clementinoVoyages = this.clementino + "/voyages";

  static clementinoTournees = this.clementino + "/tournees";

  static clementinoTickets = this.clementino + "/tickets";

  static clementinoTarifs = this.clementino + "/tarifs";

  static clementinoConfigurations = this.clementino + "/configurations";

  static passenger = this.apiBaseUrl + "/passenger";

  static expeditionsInternal = this.apiBaseUrl + "/expeditions";
}

export class ApiRouteSecond {
  static apiBasUrl = process.env.REACT_APP_MOPOZZI_API_BASE_URL || process.env.REACT_APP_DIGIASSUR_BASE_URL || "http://localhost:8000";

  static dashbordinfo = this.apiBasUrl + "/dashboard-info";
}

